import { Component, OnInit, OnDestroy } from "@angular/core";
import { BaseComponent } from "../shared/components/base.component";
import { InterventionTeamService } from "../shared/service/interventionTeamService";
import { BuildingService } from "../shared/service/building-service";
import { ApplicationConfig } from "src/app/config/application.config";
import { Building } from "../shared/model/building";
import { UrgencyType, ActionStatusType } from "../shared/enums/enums";
import { BuildingActionsSummary } from '../shared/model/buildingActionsSummary';
import { Subscription } from 'rxjs';

@Component({
  selector: "app-buildings",
  templateUrl: "./buildings.component.html",
  styleUrls: ["./buildings.component.scss"]
})
export class BuildingsComponent extends BaseComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];

  public buildingActionsList: BuildingActionsSummary[] = [];
  public areBuildingsLoading: boolean;

  constructor(
    private interventionTeamService: InterventionTeamService,
    private buildingService: BuildingService,
    private config: ApplicationConfig
  ) {
    super();
  }

  ngOnInit() {
    this.areBuildingsLoading = true;
    this.subscriptions.push(this.interventionTeamService.selectedInterventionTeam.subscribe(team => {
      this.buildingService.getBuildingsWithActions(team.id).subscribe(buildingActionsList => {
        this.areBuildingsLoading = false;
        this.buildingActionsList = buildingActionsList;
      });
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];
  }

  public getCover(building: Building): string {
    return building.coverUrl
      ? building.coverUrl
      : this.config.BUILDING_PLACEHOLDER_URL;
  }

  public doesBuildingHaveJobs(buildingActions: BuildingActionsSummary): boolean {
    var statuses = [ActionStatusType.ACCEPTED, ActionStatusType.EXECUTING, ActionStatusType.SENT];
    return buildingActions.actions.some(a => statuses.includes(a.status));
  }

  public doesBuildingHaveUrgentJobs(buildingActions: BuildingActionsSummary): boolean {
    return buildingActions.actions.some(a => a.urgency == UrgencyType.URGENT); //TODO check for issue urgency aswell
  }

  public doesBuildingHaveJobsWithHighPriority(buildingActions: BuildingActionsSummary): boolean {
    return buildingActions.actions.some(a => a.priority == 1);
  }
}
